import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/security/cve-lookup/[id]/CVEDetailClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/security/cve-lookup/[id]/ServiceUnavailable.tsx");
